<template>
  <div id="projectLists">
    <el-row class="header-row">
      <el-col :span="24">
        <h3 class="el-page-header">My Projects</h3>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/my-projects' }">My Projects</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: `/my-projects/${project.id}` }">{{ project.projectID }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <div v-loading="loading" v-if="loading" style="height: 120px" element-loading-spinner="atom-audit-loader"></div>
    <el-card v-show="!loading">
      <coderProjectViewAsAlert :project-id="$route.params.id" @change="onViewAsChange" />
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="Project" name="details" style="min-height: 400px">
          <h4 class="headerWithBorder">Details</h4>
          <el-form v-if="!loading" size="mini" label-position="left" label-width="130px">
            <el-row :gutter="20">
              <el-col :lg="8" :md="12">
                <el-form-item size="mini" label="ID">
                  <div :class="'el-input el-input--mini is-disabled'">
                    <input id="projectID" :class="'el-input__inner'" :disabled="true" maxlength="200" type="text" :value="projectID" />
                  </div>
                </el-form-item>
                <el-form-item size="mini" label="Type">
                  <hia-el-select :disabled="true" v-model="projectTypeId" placeholder="Project Type" :clearable="false" :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.projectTypes.list"></hia-el-select>
                </el-form-item>
                <el-form-item prop="name" label="Process">
                  <hia-el-select placeholder="Process" :disabled="true" :value="project.processId" clearable :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.projectProcesses.list"></hia-el-select>
                </el-form-item>
                <el-form-item size="mini" label="Tags">
                  <el-select class="multiSelect" :disabled="true" size="mini" v-model="identifierSelectionsArray" filterable multiple collapse-tags placeholder="Tags">
                    <el-option v-for="item in dropdowns.projectIdentifiers.list" :key="item.key" :label="item.value" :value="item.key" :disabled="item.inactive"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item size="mini" label="Start Date">
                  <el-date-picker :disabled="true" size="mini" type="date" v-model="startDate" id="startDate" format="MM/dd/yyyy" :clearable="false"> </el-date-picker>
                </el-form-item>
                <el-form-item size="mini" label="End Date">
                  <el-date-picker :disabled="true" size="mini" type="date" v-model="endDate" id="endDate" format="MM/dd/yyyy"> </el-date-picker>
                </el-form-item>
                <el-form-item size="mini" label="Status">
                  <hia-el-select :disabled="true" v-model="projectStatusId" placeholder="Project Status" :clearable="false" :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.projectStatus.list"></hia-el-select>
                </el-form-item>
                <el-form-item size="mini" label="Lead" prop="leadId">
                  <hia-el-select :disabled="true" v-model="leadId" placeholder="Lead" filterable clearable itemkey="key" label="value" :dropdowns="dropdowns.allAuditorUsers.list"></hia-el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item size="mini" label="Created By">
                  <el-input size="mini" id="userId" :value="getUserById(project.userId)" :disabled="true"> </el-input>
                </el-form-item>
                <el-form-item size="mini" label="Default Facility">
                  <hia-el-select :disabled="true" v-model="clientId" placeholder="Facility" clearable :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.clients.list"></hia-el-select>
                </el-form-item>
                <el-form-item v-if="['Professional Fee', 'Outpatient', 'Ambulatory'].includes(project.projectTypeName)" size="mini" label="Default Code Type">
                  <hia-el-select :disabled="true" v-model="defaultCodeType" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" clearable filterable> </hia-el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-collapse v-model="activeNames" style="margin-top: 10px">
            <el-collapse-item title="Dashboard" name="dashboard">
              <div style="margin: 20px 0px 0px 0px" v-if="!loading">
                <dashboards :key="'dashboard-' + viewAsKey" :drgTableIds="drgTableIds" :proRecordIds="proRecordIds" :ascTableIds="ascTableIds" :type="compDashboardType" :myProjects="true" :showLevel2Audit="project.projectReviewTypeId === 2">
                  <template v-slot:filters> &nbsp; </template>
                  <template v-slot:stats> &nbsp; </template>
                </dashboards>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <el-tab-pane v-if="project.projectTypeName === 'Inpatient'" label="Inpatient Charts" name="Inpatient">
          <coderInpatientList :key="'ip-' + viewAsKey"></coderInpatientList>
        </el-tab-pane>
        <el-tab-pane v-if="project.projectTypeName === 'Outpatient'" label="Outpatient Charts" name="Outpatient">
          <coderOutpatientList :key="'op-' + viewAsKey"></coderOutpatientList>
        </el-tab-pane>
        <el-tab-pane v-if="project.projectTypeName === 'Ambulatory'" label="Ambulatory Charts" name="Ambulatory">
          <coderAmbulatoryList :key="'amb-' + viewAsKey"></coderAmbulatoryList>
        </el-tab-pane>
        <el-tab-pane v-if="project.projectTypeName === 'Professional Fee'" label="Pro Charts" name="Professional Fee">
          <coderProList :key="'pro-' + viewAsKey"></coderProList>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { createHelpers } from 'vuex-map-fields'
  import coderInpatientList from '@/views/coder/inpatient/coderInpatientList'
  import coderOutpatientList from '@/views/coder/outpatient/coderOutpatientList'
  import coderAmbulatoryList from '@/views/coder/ambulatory/coderAmbulatoryList'
  import coderProList from '@/views/coder/pro/coderProList'
  import dashboards from '@/views/reports/dashboards'
  import coderProjectViewAsAlert from './coderProjectViewAsAlert.vue'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  const { mapFields } = createHelpers({
    getterType: 'managedLists/projects/getField',
    mutationType: 'managedLists/projects/updateField'
  })
  export default {
    name: 'coderProject',
    mixins: [HiaAuthorization],
    data() {
      return {
        activeName: 'details',
        activeNames: ['dashboard'],
        statusFilters: [3, 4],
        deactivated: false,
        loading: false,
        dropdownsNeeded: ['clients', 'projectIdentifiers', 'projectTypes', 'coders', 'allAuditorUsers', 'codeTypes', 'outpatientGroupers', 'reviewStatus', 'projectStatus', 'projectProcesses']
      }
    },
    methods: {
      ...mapActions('dropdowns/', ['GET_DROPDOWNS']),
      ...mapActions('managedLists/projects/', ['LOAD_PROJECT', 'GET_PROJECT_DASHBOARD_IDS_STATS']),
      ...mapMutations('managedLists/projects/', ['SET_PROJECTPK']),
      getUserById(userId) {
        let user = this.dropdowns.allAuditorUsers.list.find((f) => f.key === userId)
        if (user) {
          user = user.value
          return user
        }
        return user
      },
      async onViewAsChange() {
        await this.reloadProjectData(false)
      },
      async reloadProjectData(showLoading = true) {
        if (showLoading) {
          this.loading = true
        }
        const payload = {
          id: this.$route.params.id,
          statusFilters: this.statusFilters,
          isMyProjects: true
        }
        try {
          await Promise.all([this.LOAD_PROJECT(payload)])
          if (this.activeName === 'details') {
            await this.GET_PROJECT_DASHBOARD_IDS_STATS({
              id: this.id,
              statusFilters: this.statusFilters,
              projectTypeName: this.project.projectTypeName,
              isMyProjects: true
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      initialize() {
        window.document.title = 'Project'
        this.loading = true
        const payload = {
          id: this.$route.params.id,
          statusFilters: this.statusFilters,
          isMyProjects: true
        }
        this.GET_DROPDOWNS(this.dropdownsNeeded).then(
          async () => {
            await Promise.all([this.LOAD_PROJECT(payload)]).then((response) => {
              this.$nextTick(() => {
                this.loading = false
                this.setActiveTabName()
              })
            })
          },
          (error) => {
            console.log(error)
            this.loading = false
          }
        )
      },
      handleTabClick(e) {
        if (this.activeName === 'details') {
          const payload = {
            id: this.id,
            statusFilters: this.statusFilters,
            projectTypeName: this.project.projectTypeName,
            isMyProjects: true
          }
          this.GET_PROJECT_DASHBOARD_IDS_STATS(payload)
        }
      },
      setActiveTabName() {
        if (this.activeName !== 'details' && this.activeName !== this.project.projectTypeName) {
          this.activeName = 'details'
        }
        if (this.$route.query.type) {
          if (this.project.projectTypeName === 'Ambulatory') {
            this.activeName = 'Ambulatory'
          } else {
            this.activeName = this.$route.query.type
          }
        }
      }
    },
    deactivated: function () {
      this.loading = true
      this.deactivated = true
    },
    created: function () {
      this.initialize()
    },
    activated: function () {
      if (this.deactivated) {
        this.initialize()
      }
      this.deactivated = false
    },
    components: {
      coderInpatientList,
      coderOutpatientList,
      coderAmbulatoryList,
      coderProList,
      dashboards,
      coderProjectViewAsAlert
    },
    computed: {
      ...mapState('dropdowns/', ['dropdowns']),
      ...mapState('managedLists/projects/', ['project', 'projectLoading', 'drgTableIds', 'proRecordIds', 'ascTableIds']),
      ...mapFields(['project.clientId', 'project.startDate', 'project.endDate', 'project.id', 'project.projectID', 'project.projectTypeId', 'project.leadId', 'project.identifierSelectionsArray', 'project.defaultCodeType', 'project.projectStatusId', 'viewAsUserId']),
      viewAsKey() {
        return this.viewAsUserId || 'self'
      },
      compDashboardType() {
        if (this.project.projectTypeName === 'Inpatient') {
          return 'ip'
        }
        if (this.project.projectTypeName === 'Outpatient') {
          return 'op'
        }
        if (this.project.projectTypeName === 'Professional Fee') {
          return 'pro'
        }
        if (this.project.projectTypeName === 'Ambulatory') {
          return 'asc'
        }
        return null
      }
    }
  }
</script>
<style scoped>
  >>> #ipSummaryTitle {
    display: none;
  }
  .multiSelect >>> .el-input__inner {
    min-height: 30px !important;
  }
</style>
